import AppState from 'AppState';
/**
 * Get the tenant id for the current tab
 */
export const getCurrentTenantId = () => {
	return AppState.tenantId;
};

/**
 * Gets the current tenant base url.
 */
export const getCurrentTenantBaseUrl = () => {
	return AppState.tenantBaseUrl;
};
